import React from 'react';

import NotificationContent from '../../shared/AppointmentContainer';
import Header from './components/Header';
import Footer from '../../shared/Footer';
import Logo from '../../shared/Logo';
import AppointmentInfo from '../../shared/AppointmentInfo';
import SquireInfo from '../../shared/SquireInfo';
import withAppointmentNotification from '../../hoc/withAppointmentNotification';
import CustomerInfo from '../../shared/CustomerInfo';
import config from '../../../../config';
import Totals from './components/Totals';
import { getCustomerPhoto } from '../../utils';

/* eslint-disable react/prop-types */
const ShopNewAppointment = ({
  shop,
  date,
  customer,
  confirmationCode,
  barber,
  service,
  duration,
  dateShort,
  appointmentNote,
  total,
  tip,
}) => (
  <div>
    <Header shopName={shop.name} barberName={barber.firstName} service={service} dateShort={dateShort} />
    <NotificationContent>
      <Logo />
      <h2 className="u-text-huge u-fw-bold u-mt-12 u-mb-10">
        {barber.firstName} has a new {service} appointment {dateShort}.
      </h2>
      <div className="u-mb-10">
        <Totals total={total} tip={tip || 0} />
      </div>
      <div className="u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4">
        New appointment
      </div>
      <div className="u-flex u-justify-content-space-between u-flex-wrap u-mb-12">
        <AppointmentInfo
          confirmationCode={confirmationCode}
          customerName={`${customer.firstName} ${customer.lastName}`}
          barberName={`${barber.firstName} ${(barber.lastName || ' ')[0]}`}
          service={service}
          date={date}
          duration={duration}
          appointmentNote={appointmentNote}
          shopLocation={shop.name}
        />
        <div className="c-appointment-info-divider u-hide-on-desktop" />
        <CustomerInfo
          customerName={`${customer.firstName} ${customer.lastName}`}
          customerNameShort={`${(customer.firstName || ' ')[0]}${(customer.lastName || ' ')[0]}`}
          customerPhoto={getCustomerPhoto(customer)}
          customerEmail={customer.email}
          customerNotes={customer.notes}
          customerPhone={customer.phone}
          customerFirstName={customer.firstName}
        />
      </div>
      <SquireInfo
        standalone
        reservationLink={`${config.commanderUrl}/appointments`}
        shopName={shop.name}
        supportLink={`${config.commanderUrl}?intercom=true`}
      />
    </NotificationContent>
    <Footer link={`${config.commanderUrl}/settings`} />
  </div>
);

export default withAppointmentNotification(ShopNewAppointment);



// WEBPACK FOOTER //
// ./src/app/notifications/shop/ShopNewAppointment/index.jsx